import React from 'react';
import IconWrapper, { IIconWrapperProps } from '../Wrapper';

const ArrowUp: React.FC<Omit<IIconWrapperProps, 'children'>> = (props) => {
    return (
        <IconWrapper {...props}>
            <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 8L8 2L2 8" stroke="#3B454F" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </IconWrapper>
    );
}

export default ArrowUp;